@if( client$ | async; ) {
    <main class="main-section">
        <div>
            <img src="assets/img/image-header.jpg" alt="" class="image-header">
        </div>
        <div class="greeting">
            <h1>Hola {{ otpService.loadCachedClient().name }}</h1>
            <h2>{{ localeService.landing.body }}</h2>
        </div>
        <div class="btn-group">
            <button class="btn-primary" (click)="onClick()" [disabled]="isBtnDisabled"><b>Solicitar código</b></button>
        </div>
    </main>
}